<template>
<div>
    <!--{{FilterJson}}-->
    <StatelessCheetah :FilterOptions="QSFilterOptions" @FilterOptionsChanged="FilterOptionsChanged" />
</div>
</template>

<script>
import StatelessCheetah from './StatelessCheetah.vue';
	
export default {
	name: 'StatefulCheetah',
    components: { StatelessCheetah },
    computed: {
        FilterJson() { return JSON.stringify(this.QSFilterOptions); }
    },
    mounted() {
        if (this.StateLocation == 'internal') {

        }
    },
    methods: {
        FilterOptionsChanged(fo) {
            //kzalert(JSON.stringify(fo))
            var filterCopy = JSON.parse(JSON.stringify(this.QSFilterOptions));

            var filterQuery = {};

            var _this = this;
            $.each(fo, function(k, v) {
                filterCopy[k] = v;
            });
            
            this.$router.push({ query: filterCopy})

        }
    },
    props: {
        QSFilterOptions: Object
    }
}
	
</script>